<template>
  <div class="swiperJob" :class="{ swiperObj: $store.state.innerWidth >= 815 }">
    <div class="swiperContent" ref="content">
      <swiper :options="swiperOption" v-if="showSwiper" :class="{ 'padding-30': showBtn }" class="swiperCarrousel SwiperArticles">
        <swiper-slide
          class="swiper-slide box-slide"
          :class="{ 'swiper-no-swiping': !canSwiper }"
          v-for="(occupation, index) in occupationList"
          :key="index"
        >
          <div class="hotOccupation-contain" ref="OccupationContain" @click="goJobDetail(occupation)">
              <div class="hotOccupation-img" ref="OccupationImg">
                <img :src="occupation.imageCode" :alt="$store.getters.getContent(occupation.title)">
              </div>
              <div class="hotOccupation-content" ref="OccupationContent">
                <!-- <div class="hotOccupation-jobFunction" v-for="(jobFun ,index) in occupation.jobFunction" :key="index">
                  {{ $store.getters.getContent(jobFun.title) }}
                </div> -->
                <div class="hotOccupation-name mainColor">
                  <a href="javascript:;" style="color: inherit">
                    <h4>{{ $store.getters.getContent(occupation.title) }}</h4>
                  </a>
                </div>
                <div class="hotOccupation-desc">
                  <p>{{ $store.getters.getContent(occupation.description) }}</p>
                </div>
              </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-occupation-prev swiper-occupation-btn" v-if="showBtn" slot="button-prev">
        <i class="icon-arrow-down"></i>
      </div>
      <div class="swiper-occupation-next swiper-occupation-btn" v-if="showBtn" slot="button-next">
        <i class="icon-arrow-down"></i>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  name: "SwiperOccupation",
  data() {
    return {
      totalRows: 0,
      showBtn: true,
      canSwiper: true,
      showSwiper: false,
      swiperOption: {
        autoHeight: true,
        slidesPerView: 2.2,
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-occupation-next",
          prevEl: ".swiper-occupation-prev",
        },
      },
    };
  },
  computed: {
    innerwidth() {
      return this.$store.state.innerWidth;
    },
    language() {
      return this.$store.state.language;
    },
    fontsize() {
      return this.$store.state.fontSize;
    },
  },
  watch: {
    innerwidth(news, old) {
      this.showSwiper = false;
      this.setWidth();
    },
    occupationList: function (n, o) {
      this.setWidth();
    },
    language: function (n, o) {
      this.setWidth();
    },
    fontsize: function (n, o) {
      debugger;
      this.setWidth();
    },
  },
  props: {
    callback: null,
    occupationList: null,
  },
  methods: {
    goJobDetail: function (item) {
      this.$router.push({ 
        path: "/occupationDetails/" + encodeURIComponent(item.id), 
        query: { 
          "lang": this.$store.state.language,
          "name":this.$store.getters.replaceEvent(this.$store.getters.getContent(item.title))
      }, });
			window.scrollTo(0, 0);
      if (this.callback) this.callback();
    },
    setWidth: function () {
      var that = this;
      this.$refs.content.style.width = "100%";
      if (this.$store.state.innerWidth >= 1345) {
        this.showBtn = false;
        this.canSwiper = false;
      } else if (this.$store.state.innerWidth >= 1080) {
        this.showBtn = true;
        this.canSwiper = false;
      } else if (this.$store.state.innerWidth >= 815) {
        this.showBtn = true;
        this.canSwiper = false;
      } else {
        this.showBtn = false;
        this.canSwiper = true;
        this.$refs.content.style.width = "100%";
      }

      if (this.$store.state.innerWidth >= 1345) {
        var space = (1320 - 320 * 4) / 3;
        this.swiperOption = {
          slidesPerView: 4,
          spaceBetween: space,
          navigation: {
            nextEl: ".swiper-occupation-next",
            prevEl: ".swiper-occupation-prev",
          },
        };
      } else if (this.$store.state.innerWidth >= 1080) {
        var space = (this.$store.state.innerWidth - 80 - 320 * 3) / 2;
        this.swiperOption = {
          slidesPerView: 3,
          spaceBetween: space,
          navigation: {
            nextEl: ".swiper-occupation-next",
            prevEl: ".swiper-occupation-prev",
          },
        };
      } else if (this.$store.state.innerWidth >= 815) {
        this.swiperOption = {
          slidesPerView: 2.5,
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-occupation-next",
            prevEl: ".swiper-occupation-prev",
          },
        };
      } else if (this.$store.state.innerWidth > 768) {
        this.swiperOption = {
          slidesPerView: 2.4,
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-occupation-next",
            prevEl: ".swiper-occupation-prev",
          },
        };
      } else if (this.$store.state.innerWidth > 650) {
        this.swiperOption = {
          slidesPerView: 2.2,
          spaceBetween: 5,
          navigation: {
            nextEl: ".swiper-occupation-next",
            prevEl: ".swiper-occupation-prev",
          },
        };
      } else if (this.$store.state.innerWidth > 550) {
        this.swiperOption = {
          slidesPerView: 2,
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-occupation-next",
            prevEl: ".swiper-occupation-prev",
          },
        };
      } else {
        this.swiperOption = {
          slidesPerView: 1.7,
          spaceBetween: 0,
          navigation: {
            nextEl: ".swiper-occupation-next",
            prevEl: ".swiper-occupation-prev",
          },
        };
      }
      
      var that = this;
      this.showSwiper = false;
      this.$nextTick(() => {
        this.showSwiper = true;
        setTimeout(function () {
          that.setHeightEvent();
        });
      });
    },
    maxValue: function max(arr){
      var num = arr[0];
      for(var i=0;i<arr.length;i++){
        if(num < arr[i]){
          num = arr[i]
        }
      }
      return num;
    },
    setHeightEvent: function () {
      var height = 0;

      if (this.$refs.OccupationContain) {
        var rate = this.$refs.OccupationImg[0].clientWidth / 240
        var imgHeight = Math.round(180*rate)
        var heightArr = [];
        for (var i = 0; i < this.$refs.OccupationContent.length; i++) {
          heightArr.push(this.$refs.OccupationContent[i].clientHeight)
        }
        var maxHeight = this.maxValue(heightArr);
        // height = imgHeight + maxHeight + 5

        if(this.$store.state.innerWidth > 456) {
          height = 180 + maxHeight + 5
        } else {
          height = 135 + maxHeight + 5
        }

        for (var i = 0; i < this.$refs.OccupationContain.length; i++) {
          this.$refs.OccupationContain[i].style.height = height + "px";
        }
      }
    },
  },
  mounted() {
    // this.mySwiper = new Swiper('.swiper-container')
    this.setWidth();
    var that = this;
    setTimeout(function () {
      that.setWidth();
    }, 500);
  },
};
</script>